<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" routerLink="/prequalifications">
    <span id="title">PCBU1 Pre-Qualifications</span>
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <span class="mr-auto"></span>

    <form tourAnchor="tour.search" class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
      <input
        class="form-control ml-0 mr-2 my-1"
        type="search"
        [(ngModel)]="dataSource.search"
        name="search"
        placeholder="Search"
        aria-label="Search" />

      <button
        mat-raised-button
        color="secondary"
        type="submit"
        class="mx-0 my-1"
        id="searchButton">
        <mat-icon>search</mat-icon> Search
      </button>
    </form>
  </div>
</nav>

<div class="mat-elevation-z8 scroll-box">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="name" matSortDisableClear matSortDirection="asc">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        #
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ prequalification.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Name
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ prequalification.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="client">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Client
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ prequalification.account.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="score">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        H&S Score
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding"
        [appColorPercent]="prequalification | prequalScore">
        {{ prequalification.score }}%
      </td>
    </ng-container>

    <ng-container matColumnDef="items">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Documents
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ prequalification.items.length }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ (prequalification.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At (UTC)
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ (prequalification.date_created * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_modified">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Last Updated At
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ (prequalification.date_modified * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_modified_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Last Updated At (UTC)
      </th>
      <td mat-cell *matCellDef="let prequalification" class="no-padding">
        {{ (prequalification.date_modified * 1000) | timezoneConvertUTCMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>
      <td mat-cell *matCellDef="let prequalification">
        <button type="button" mat-button (click)="view(prequalification.id)">
          View
        </button>
        <button type="button" mat-button (click)="edit(prequalification.id)">
          Edit
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
  </table>

  <mat-paginator
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
